import { CompartmentListURIParams } from '../models';

export class CompartmentListLoad {
  public static readonly type = '[CompartmentList] Load';
  constructor(public payload: CompartmentListURIParams) {}
}

export class CompartmentListInitialState {
  public static readonly type = '[CompartmentList] Set initial state';
}
